export const ChargeType = {
  FlatRate: 'Flat rate',
  Service: 'Service',
  Hourly: 'Hourly',
  Daily: 'Daily',
  Monthly: 'Monthly',
  Sqft: 'Sqft',
  Sqm: 'Sqm',
  CF: 'CF',
  CY: 'CY',
  Image: 'Image',
  Picture: 'Picture',
  Room: 'Room',
  Floor: 'Floor',
  Item: 'Item',
  Page: 'Page',
  Acre: 'Acre',
  Foot: 'Foot',
  Meter: 'Meter',
  Visit: 'Visit',
  ContactForQuote: 'Contact for Quote',
  ContactForPrice: 'Contact for price',
};

export const ChargePrefix = {
  Service: '/service',
  Hr: '/hr',
  Day: '/day',
  Month: '/Month',
  Sqft: '/sqft',
  Sqm: '/sqm',
  CubicFoot: '/cubic foot',
  CubicYard: '/cubic yard',
  Image: '/image',
  Room: '/room',
  Floor: '/floor',
  Item: '/item',
  Page: '/page',
  Acre: '/acre',
  Foot: '/foot',
  Meter: '/meter',
  Visit: '/visit',
};
